import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  MakeDirectSaleNegotiationBodyDto,
  MakeDirectSaleNegotiationProposalResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiMakeDirectSaleProposal = (
    directSaleId: MaybeRef<string | undefined | null>,
    makeDirectSaleNegotiationBodyDto: MaybeRef<MakeDirectSaleNegotiationBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
makeDirectSaleNegotiationBodyDto = unref(makeDirectSaleNegotiationBodyDto);
      
      return fetchApiInstance<MakeDirectSaleNegotiationProposalResponseDto>(
      {url: `/directSaleNegotiations/${directSaleId}/negotiationProposal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: makeDirectSaleNegotiationBodyDto
    },
      options);
    }
  


export const getApiMakeDirectSaleProposalMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>, TError,{directSaleId: string;data: BodyType<MakeDirectSaleNegotiationBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>, TError,{directSaleId: string;data: BodyType<MakeDirectSaleNegotiationBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>, {directSaleId: string;data: BodyType<MakeDirectSaleNegotiationBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiMakeDirectSaleProposal(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiMakeDirectSaleProposalMutationResult = NonNullable<Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>>
    export type ApiMakeDirectSaleProposalMutationBody = BodyType<MakeDirectSaleNegotiationBodyDto>
    export type ApiMakeDirectSaleProposalMutationError = ErrorType<BackendErrorEntity>

    export const useApiMakeDirectSaleProposal = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>, TError,{directSaleId: string;data: BodyType<MakeDirectSaleNegotiationBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiMakeDirectSaleProposal>>,
        TError,
        {directSaleId: string;data: BodyType<MakeDirectSaleNegotiationBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiMakeDirectSaleProposalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    